import { createContext, useContext, useState } from "react";

const BookingContext = createContext(null);

export function BookingProvider({ children }) {
  const [open, setOpen] = useState(false);
  const [preset, setPreset] = useState("");
  const [presetType, setPresetType] = useState("free");
  const openBooking = (interest = "", typeId = "free") => {
    setPreset(interest);
    setPresetType(typeId);
    setOpen(true);
  };
  return (
    <BookingContext.Provider value={{ open, setOpen, openBooking, preset, presetType }}>
      {children}
    </BookingContext.Provider>
  );
}

export const useBooking = () => useContext(BookingContext);
